import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import { Desktop, Mobile } from '../../App';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { AnimatedDashboard } from '../../components/animation/AnimatedDashboard';
import Spinner from '../../components/common/Spinner';
import { BACKOFFICE_NAME, flipMeTitle } from '../../helpers/helperFunctions';
import {
  BIG_WHALE,
  KYC_START,
  SETTINGS_SECURITY,
  SETTINGS_VIRTUAL_OFFICE,
  FLIPME_CARDS,
  AKASHA,
  POWERPACKS,
  FINUP_HUBS
  // EARN_BET,
  // DUBAI_TOKEN_PROMOTION
} from '../../routes/routes';
import { color, colors } from '../../styles/GlobalStyles';
import {
  checkAkashaModal,
  getDashboardInfo,
  updateWillyCoins
} from './Dashboard.actions';
import { PackageRankUpgradeNotification } from './Dashboard.types';
import { DashboardNotification } from './DashboardNotification';
import { EarningsComponent } from './EarningsComponent';
import { MoneyBack } from './MoneyBack';
import { NumberOfMembers } from './NumberOfMembers';

import { RankNotification } from './RankNotification';
import { StatisticalComponent } from './StatisticalComponent';
import { SubscriptionWarning } from './SubscriptionWarning';

import { WelcomeSidebar } from './WelcomeSidebar';

import finupBanner from '../../assets/images/backoffice/finup/finupBanner.png';
import finupBannerMobile from '../../assets/images/backoffice/finup/finupBannerMobile.png';

import powerPackBanner from '../../assets/images/backoffice/powerPacks/powerPackBanner.png';
import powerPackBannerMobile from '../../assets/images/backoffice/powerPacks/powerPackBannerMobile.png';

import akashaNotRestricted from '../../assets/images/backoffice/akasha/akashaNotRestrictedBanner.png';
import akashaNotRestrictedMobile from '../../assets/images/backoffice/akasha/akashaNotRestrictedBannerMobile.png';

import flipMe from '../../assets/images/backoffice/flipMe/flipMeBanner.png';
import flipMeMobile from '../../assets/images/backoffice/flipMe/flipMeBannerMobile.png';

import flipMeCard from '../../assets/images/backoffice/flipMe/flipMeCardBanner.png';
import flipMeCardMobile from '../../assets/images/backoffice/flipMe/flipMeCardBannerMobile.png';
import flipMeDisabled from '../../assets/images/backoffice/flipMe/flipMeDisabled.png';
import flipMeDisabledMobile from '../../assets/images/backoffice/flipMe/flipMeDisabledMobile.png';

// import earnBet from '../../assets/images/backoffice/earnBet/earnBet.png';
// import earnBetMobile from '../../assets/images/backoffice/earnBet/earnBetMobile.png';

import licencesPromo from '../../assets/images/backoffice/licencesPromo/licencesPromo.png';
import licencesPromoMobile from '../../assets/images/backoffice/licencesPromo/licencesPromoMobile.png';

import bigWhaleBanner from '../../assets/images/backoffice/bigWhale/bigWhaleBanner.png';
import bigWhaleBannerMobile from '../../assets/images/backoffice/bigWhale/bigWhaleBannerMobile.png';

import { WillyMemeCoinsBanner } from './WillyCoins/WillyMemeCoinsBanner';

import { IconTitleStyled } from './DashboardStyled';
import {
  ConnectWallet,
  ConnectWalletStatus
} from '../FlipMeWallet/FlipMeBanner';
import {
  flipMeGetInfo,
  flipMeRankRewards,
  redeemFlipmeCardInRank
} from '../FlipMeWallet/FlipMeWallet.actions';
import { FlipMeWallet } from '../FlipMeWallet/FlipMeWallet';
import { SidebarModal } from '../../components/common/Sidebar/Sidebar';
import { RedeemFlipmeCards } from '../Portfolio/RedeemFlipmeCards/RedeemFlipmeCards';
import { RedeemFlipmeCardsStepsEnum } from '../Portfolio/RedeemFlipmeCards/types';
import { CaptionText, H3, H5, P1, P2, P3 } from '../../styles/FontStyles';
import { Flex } from '../../styles/stylesStyled';
import { Button, Flexed } from '../../styles/GlobalComponents';
import Modal from 'react-modal';

const Dashboard = () => {
  const dispatch = useAppDispatch();

  const { t } = useTranslation('dashboard');
  const {
    user,
    kycStatus,
    isSideModalChecked,
    isCanadaRestrictedUser,
    canBuyBigWhale,
    isAkashaPopupChecked,
    canBuyAkashaPackages,
    canBuyPowerPacksPackages,
    canBuyTradingPackages
  } = useAppSelector((state) => state.auth.userInfo);

  const [modal, setModal] = useState(!isAkashaPopupChecked);

  const { dashboardInfo, joinedAfterCount, willyCoins, loading } =
    useAppSelector((state) => state.dashboard);

  const {
    isRankRedeemAvailable,
    flipMeStatus,
    flipmeCard: flipmeCardData
  } = useAppSelector((state) => state.wallets);

  const [welcome, setWelcome] = useState(!isSideModalChecked);
  const [isFlipmeCardOpen, setIsFlipmeCardOpen] = useState<boolean>(false);
  const [stepFlipmeCard, setStepFlipmeCard] = useState(1);
  const [redeemCardsModal, setRedeemCardsModal] = useState(false);

  const [redeemFlipmeCardsStep, setRedeemFlipmeCardsStep] =
    useState<RedeemFlipmeCardsStepsEnum>(RedeemFlipmeCardsStepsEnum.STEP1);

  const history = useHistory();

  const renderAkasha = () => {
    return (
      <Link to={AKASHA}>
        {/* <Desktop> */}
        <img
          src={akashaNotRestricted}
          alt='akashaBanner'
          style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
        />
        {/* </Desktop>
        <Mobile>
          <img
            src={akashaNotRestrictedMobile}
            alt='akashaMobile'
            style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
          />
        </Mobile> */}
      </Link>
    );
  };

  useEffect(() => {
    dispatch(getDashboardInfo());
  }, [dispatch]);

  const KycPackageNotifications = () => {
    if (!kycStatus?.isKycCompleted && !kycStatus?.isKycVerified) {
      return (
        <DashboardNotification
          pill={t('kyc_pill')}
          title={t('kyc_title')}
          text={t('kyc_text')}
          buttonOnClick={() => history.push(KYC_START)}
          buttonText={t('verify_now')}
        />
      );
    } else return null;
  };

  const StartYourJourneyNotification = () => {
    if (!dashboardInfo?.user?.currentVirtualOfficeLicence) {
      return (
        <DashboardNotification
          pill={'take the first step today'}
          title={'Start your Journey HERE!'}
          text={`To achieve the fastest growth, start with the MaVie ${BACKOFFICE_NAME} Subscription.`}
          buttonText={`Start with a ${BACKOFFICE_NAME}`}
          buttonOnClick={() => history.push(SETTINGS_VIRTUAL_OFFICE)}
        />
      );
    } else return null;
  };

  const SecurityNotification = () => {
    if (!dashboardInfo?.user?.settings?.signInEmailCodeVerificationEnabled) {
      return (
        <DashboardNotification
          titleColor={color.colors.error500}
          pill={t('notifications.security.pill')}
          title={t('notifications.security.title')}
          text={t('notifications.security.text')}
          buttonText={t('notifications.security.button')}
          buttonOnClick={() => history.push(SETTINGS_SECURITY)}
        />
      );
    } else return null;
  };

  if (loading && !dashboardInfo) return <Spinner fullScreen={true} />;

  const cardStatuses = (status: string) => {
    if (status === 'error') {
      return colors.error500;
    } else if (status === 'redeemed') {
      return colors.success500;
    } else {
      return colors.warning;
    }
  };

  return (
    <AnimatedDashboard zoom key={'dashboardInfo'}>
      <div style={{ margin: '70px 0' }}>
        <IconTitleStyled>{t('earnings.notifications')}</IconTitleStyled>

        <StartYourJourneyNotification />

        {dashboardInfo?.packageRankUpgradeNotifications?.map(
          (notification: PackageRankUpgradeNotification, index: number) => {
            return <RankNotification notification={notification} key={index} />;
          }
        )}

        {canBuyTradingPackages && (
          <Link to={FINUP_HUBS}>
            <Desktop>
              <img
                src={finupBanner}
                alt='finupBanner'
                style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
              />
            </Desktop>
            <Mobile>
              <img
                src={finupBannerMobile}
                alt='finupBannerMobile'
                style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
              />
            </Mobile>
          </Link>
        )}

        <SubscriptionWarning />
        {canBuyPowerPacksPackages && (
          <Link to={POWERPACKS}>
            <Desktop>
              <img
                src={powerPackBanner}
                alt='powerPack'
                style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
              />
            </Desktop>
            <Mobile>
              <img
                src={powerPackBannerMobile}
                alt='powerPack'
                style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
              />
            </Mobile>
          </Link>
        )}

        {!isCanadaRestrictedUser && canBuyBigWhale && (
          <Link to={BIG_WHALE}>
            <Desktop>
              <img
                src={bigWhaleBanner}
                alt='bigWhaleBanner'
                style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
              />
            </Desktop>
            <Mobile>
              <img
                src={bigWhaleBannerMobile}
                alt='bigWhaleBannerMobile'
                style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
              />
            </Mobile>
          </Link>
        )}

        {/* {!isCanadaRestrictedUser && (
          <Link to={SETTINGS_VIRTUAL_OFFICE}>
            <Desktop>
              <img
                src={licencesPromo}
                alt='licencesPromo'
                style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
              />
            </Desktop>
            <Mobile>
              <img
                src={licencesPromoMobile}
                alt='licencesPromoMobile'
                style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
              />
            </Mobile>
          </Link>
        )} */}

        {/* FAST START BONUS */}
        {!isCanadaRestrictedUser && <MoneyBack />}

        {/* MY OVERVIEW */}
        <EarningsComponent user={user} backOffice={dashboardInfo} />
        {/* STATISTICAL DATA */}
        <StatisticalComponent backOffice={dashboardInfo} />
        {/* <UnilevelDashboard /> */}

        {/* <ExclusiveGaming /> */}
        {/* <Exclusive /> */}

        <KycPackageNotifications />

        <SecurityNotification />

        <NumberOfMembers backOffice={dashboardInfo} count={joinedAfterCount} />
      </div>
      {!isCanadaRestrictedUser && (
        <WelcomeSidebar open={welcome} setOpen={setWelcome} />
      )}

      <RedeemFlipmeCards
        redeemCardsModal={redeemCardsModal}
        setRedeemCardsModal={setRedeemCardsModal}
        redeemFlipmeCardsStep={redeemFlipmeCardsStep}
        setRedeemFlipmeCardsStep={setRedeemFlipmeCardsStep}
        packageId={null}
      />

      <SidebarModal
        isOpen={isFlipmeCardOpen}
        setOpen={() => {
          setIsFlipmeCardOpen(!isFlipmeCardOpen);
          stepFlipmeCard === ConnectWallet.SECOND_STEP &&
            dispatch(flipMeGetInfo());
        }}
        title={flipMeTitle(stepFlipmeCard)}
        sidebarWidth={'520px'}>
        <FlipMeWallet
          setStep={setStepFlipmeCard}
          step={stepFlipmeCard}
          setIsOpen={setIsFlipmeCardOpen}
        />
      </SidebarModal>

      <Modal
        isOpen={modal}
        onRequestClose={() => setModal(!modal)}
        overlayClassName='myoverlay'
        closeTimeoutMS={500}
        ariaHideApp={false}
        className={'cameraModal'}>
        <Flexed p='30px' column>
          <H3 caps mb='30' center>
            Super Node Update:
          </H3>
          <P2 mb='40' color={colors.neutral700}>
            Starting August, 14th 2025, we'll remove all $AK1111 tokens from
            your Super Nodes and replace them with $ULX on a dollar-for-dollar
            basis (USD value at transition). <br /> This strategic move protects
            our community, eliminates external risks, and strengthens Mavie's
            independence. No action needed—it's automatic. Your rewards and
            functionality remain unchanged.
          </P2>
          <Button
            onClick={() => {
              setModal(!modal);
              dispatch(checkAkashaModal(history));
            }}>
            Close
          </Button>
        </Flexed>
      </Modal>
    </AnimatedDashboard>
  );
};

export default Dashboard;
